<div ngbDropdown class="vox-dropdown-input">
  <button type="button" ngbDropdownToggle>{{selectedPlatform}}</button>
  <div ngbDropdownMenu>
    <button type="button" ngbDropdownItem *ngFor="let platform of PLATFORMS"
      (click)="selectPlatform(platform)">{{platform}}</button>
  </div>
</div>